import * as jsPdf from 'jspdf';
import { EInputMask } from 'src/Components/EInput';
import { IOperatorRegionPrice } from 'src/Interfaces/AdminInterface';
import { IOperator } from "src/Interfaces/WellInterface";
import { ITenant } from "src/Stores/Tenant/TenantStore";
import { fillEmptyRows } from '../MudReport/PopDataMud';
import { textArrayInBoxes } from "../PopulateDataMethods";
import * as MM from './SpecMilsOperatorPriceList';


const mask = new EInputMask();

interface IProductCatagoryList {
    category: string;
    products: IOperatorRegionPrice[];
}

export const drawOperatorPriceList = (tenant: ITenant, operator: IOperator, regionId: string, operatorRegionPrices: IOperatorRegionPrice[], logoBlob: HTMLImageElement, operatorList: jsPdf) => {
    drawHeader(tenant, operator, regionId, logoBlob, operatorList);
    const categoryList = getCategoryList(operatorRegionPrices);
    let count = drawCategoryList(categoryList.sort((a, b) => a.category.localeCompare(b.category)), 0, operatorList);
    while (count < categoryList.length) {
        operatorList.addPage();
        drawHeader(tenant, operator, regionId, logoBlob, operatorList);
        count = drawCategoryList(categoryList.sort((a, b) => a.category.localeCompare(b.category)), count, operatorList);
    }
};

const drawHeader = (tenant: ITenant, operator: IOperator, regionId: string, logoBlob: HTMLImageElement, volumeReport: jsPdf) => {
    volumeReport.addImage(logoBlob, 'PNG', MM.LOGO_LEFT, MM.LOGO_TOP, MM.LOGO_WIDTH, MM.LOGO_HEIGHT);
    popHeaders(tenant, operator, regionId, volumeReport);
};

const popHeaders = (tenant: ITenant, operator: IOperator, regionId: string, operatorList: jsPdf) => {
    const tenantDataArr = [
        [tenant.address1, tenant.address2, mask.phone(tenant.phone)],
        [tenant.webSite, tenant.contactEmail]
    ];

    const region = operator.regions.find(reg => reg.id === regionId);
    const regionName = region ? region.name : '';
    
    const dateArr = operator.effectiveDate ? operator.effectiveDate.split('-') : [];
    let dateString = '';
    if (dateArr.length === 3) {
        dateString = dateArr[1] + '/' + dateArr[2] + '/' + dateArr[0];
    }
    
    const operatorData = [
        [`Product Price List for ${operator.operatorName} - ${regionName} - Effective ${dateString}`],
        [undefined]
    ];

    const productHeaders = [
        [undefined],
        [
            {
                cols: 2,
                text: 'Product'
            },
            {
                cols: 1,
                text: '',
            },
            {
                cols: 1,
                text: '',
            },
        ]
    ];

    const productLabels = [
        [undefined],
        [
            {
                cols: 2,
                text: ''
            },
            {
                cols: 1,
                text: 'Unit Size',
            },
            {
                cols: 1,
                text: 'Price',
            },
        ]
    ];
    operatorList.setFontSize(12);
    operatorList.setFontStyle('bold');
    textArrayInBoxes(tenantDataArr, MM.TENANT_INFO_LEFT, MM.TENANT_INFO_TOP, MM.TENANT_INFO_WIDTH, MM.TENANT_INFO_HEIGHT, 'center', operatorList);
    textArrayInBoxes(operatorData, MM.SUB_HEADER_LEFT, MM.SUB_HEADER_TOP, MM.SUB_HEADER_WIDTH, MM.SUB_HEADER_HEIGHT, 'left', operatorList);
    textArrayInBoxes(productHeaders, MM.DATA_LEFT, MM.SUB_HEADER_TOP, MM.COLUMN_WIDTH, MM.SUB_HEADER_HEIGHT, 'left', operatorList);
    textArrayInBoxes(productLabels, MM.DATA_LEFT, MM.SUB_HEADER_TOP, MM.COLUMN_WIDTH, MM.SUB_HEADER_HEIGHT, 'right', operatorList);
    textArrayInBoxes(productHeaders, MM.COLUMN_TWO_LEFT, MM.SUB_HEADER_TOP, MM.COLUMN_WIDTH, MM.SUB_HEADER_HEIGHT, 'left', operatorList);
    textArrayInBoxes(productLabels, MM.COLUMN_TWO_LEFT, MM.SUB_HEADER_TOP, MM.COLUMN_WIDTH, MM.SUB_HEADER_HEIGHT, 'right', operatorList);
};

const getCategoryList = (operatorProductList: IOperatorRegionPrice[]) => {
    const categoryList = [] as IProductCatagoryList[];
    operatorProductList.forEach(orp => {
        const categoryItem = categoryList.find(pc => pc.category === orp.category);
        if (categoryItem) {
            categoryItem.products.push(orp);
        } else {
            const newCategoryItem: IProductCatagoryList = {
                category: orp.category,
                products: [orp]
            };
            categoryList.push(newCategoryItem);
        }
    });

    return categoryList;

};

const drawCategoryList = (categoryList: IProductCatagoryList[], startIndex: number, operatorList: jsPdf) => {
    let i = startIndex;
    let listTop = MM.DATA_TOP;
    let listHeight = (categoryList[startIndex].products.length + 1) * MM.ROW_HEIGHT;
    for (;i < categoryList.length && listTop + listHeight < MM.FULL_HEIGHT; i++) {
        const pci = categoryList[i];
        const listArrCategory = [
            [pci.category]
        ];
        fillEmptyRows(listArrCategory, pci.products.length + 1);
        const listArr = [
            [undefined]
        ] as any;

        const productNameArr = [
            [undefined]
        ] as any;

        pci.products.sort((a, b) => a.name.localeCompare(b.name)).forEach(orp => {
            const unitSize = orp.size + ' ' + orp.unit;
            const tempRow = [
                {
                    cols: 2,
                    text: ''
                },
                {
                    cols: 1,
                    text: unitSize,
                },
                {
                    cols: 1,
                    text: mask.currency(orp.price)
                }
            ];
            const prodName = [
                {
                    cols: 2,
                    text: orp.name
                },
                {
                    cols: 1,
                    text: ''
                },
                {
                    cols: 1,
                    text: ''
                },
            ];
            listArr.push(tempRow);
            productNameArr.push(prodName);
        });
        operatorList.setFontStyle('bold');
        textArrayInBoxes(listArrCategory, MM.DATA_LEFT, listTop, MM.COLUMN_WIDTH, listHeight, 'center', operatorList);
        operatorList.setFontStyle('normal');
        textArrayInBoxes(listArr, MM.DATA_LEFT, listTop, MM.COLUMN_WIDTH, listHeight, 'right', operatorList);
        textArrayInBoxes(productNameArr, MM.DATA_LEFT, listTop, MM.COLUMN_WIDTH, listHeight, 'left', operatorList);
        listTop = listTop + listHeight + MM.SECTION_GAP_WIDTH;
        if (i + 1 >= categoryList.length) {
            return i + 1;
        } else {
            listHeight = (categoryList[i + 1].products.length + 1) * MM.ROW_HEIGHT;
        }
    }

    listTop = MM.DATA_TOP;
    listHeight = (categoryList[i].products.length + 1) * MM.ROW_HEIGHT;
    for (;i < categoryList.length && listTop + listHeight < MM.FULL_HEIGHT; i++) {
        const pci = categoryList[i];
        const listArrCategory = [
            [pci.category]
        ];
        fillEmptyRows(listArrCategory, pci.products.length + 1);
        const listArr = [
            [undefined]
        ] as any;

        const productNameArr = [
            [undefined]
        ] as any;

        pci.products.sort((a, b) => a.name.localeCompare(b.name)).forEach(orp => {
            const unitSize = orp.size + ' ' + orp.unit;
            const tempRow = [
                {
                    cols: 2,
                    text: ''
                },
                {
                    cols: 1,
                    text: unitSize,
                },
                {
                    cols: 1,
                    text: mask.currency(orp.price)
                }
            ];
            const prodName = [
                {
                    cols: 2,
                    text: orp.name
                },
                {
                    cols: 1,
                    text: ''
                },
                {
                    cols: 1,
                    text: ''
                },
            ];
            listArr.push(tempRow);
            productNameArr.push(prodName);
        });
        operatorList.setFontStyle('bold');
        textArrayInBoxes(listArrCategory, MM.COLUMN_TWO_LEFT, listTop, MM.COLUMN_WIDTH, listHeight, 'center', operatorList);
        operatorList.setFontStyle('normal');
        textArrayInBoxes(listArr, MM.COLUMN_TWO_LEFT, listTop, MM.COLUMN_WIDTH, listHeight, 'right', operatorList);
        textArrayInBoxes(productNameArr, MM.COLUMN_TWO_LEFT, listTop, MM.COLUMN_WIDTH, listHeight, 'left', operatorList);
        listTop = listTop + listHeight + MM.SECTION_GAP_WIDTH;
        if (i + 1 >= categoryList.length) {
            return i + 1;
        } else {
            listHeight = (categoryList[i + 1].products.length + 1) * MM.ROW_HEIGHT;
        }
    }
    return i;
};


// WEBPACK FOOTER //
// ./src/Services/Pdf/OperatorPriceList/DrawOperatorPriceList.ts